export enum NavigationType {
    Transparent,
    White,
}